import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";
import zIndexTypes from "../../../../theme/zIndexTypes";

export const Wrapper = styled.div`
  background-color: ${(props) =>
    props.backgroundColour ? props.backgroundColour : "rgb(111, 207, 151)"};
  width: calc(100vw - 60px);
  z-index: ${zIndexTypes.flashMessage};
  min-height: 65px;
  display: flex;
  align-items: center;
  padding-left: ${(props) => (props.flashMessageIcon ? "15px" : "10px")};
  position: fixed;
  top: ${(props) => (props.showFlashMessage ? "60px" : "-100px")};
  left: 60px;
  transition: 0.2s ease-in-out;

  .fa-check {
    font-size: 1.4em;
    color: green;

    ${mediaMaxWidth.tablet`
      font-size: 1.2em;
    `}
  }

  .fa-times {
    font-size: 1.4em;
    color: #f90000;

    ${mediaMaxWidth.tablet`
      font-size: 1.2em;
    `}
  }

  ${mediaMaxWidth.tablet`
    margin-left: 0;
    min-height: 60px;
    padding: 0 15px;
    left: 0;
    width: 100vw;
  `}
`;

export const Text = styled.div`
  font-family: Komet;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2em;
  line-height: normal;
  letter-spacing: 0.015em;
  color: #333;
  margin: 15px;
  width: ${(props) =>
    props.flashMessageIcon ? "calc(100vw - 200px)" : "calc(100vw - 150px)"};

  ${mediaMaxWidth.tablet`
    font-size: 0.95em;
    width: unset;
    padding: ${(props) => (props.flashMessageIcon ? "0 20px" : "0 30px 0 0")};
    margin: 10px 0;
  `}
`;

export const CloseBtn = styled.div`
  position: absolute;
  right: 20px;
  top: 15px;
  cursor: pointer;

  svg {
    color: #fff !important;
  }

  &:hover {
    svg {
      color: #333 !important;
    }
  }

  ${mediaMaxWidth.tablet`
    right: 10px;
    top: 10px;
  `}
`;
